var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#3CDD9F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 26.5,
    fill: "#3CDD9F",
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 31a3 3 0 013-3h20a3 3 0 013 3v12a3 3 0 01-3 3H29a3 3 0 01-3-3V31zm13 6.438l-12.219-6.594 7.75 6.031-6.406 6.563 7.813-5.563L39 39.844l3.063-1.969 7.812 5.563-6.406-6.563 7.75-6.031L39 37.437z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzUiIGhlaWdodD0iNzUiIHZpZXdCb3g9IjAgMCA3NSA3NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMzcuNSIgY3k9IjM3LjUiIHI9IjM3LjUiIGZpbGw9IiMzQ0REOUYiLz4KPGNpcmNsZSBjeD0iMzcuNSIgY3k9IjM3LjUiIHI9IjI2LjUiIGZpbGw9IiMzQ0REOUYiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI2IDMxQzI2IDI5LjM0MzggMjcuMzQzOCAyOCAyOSAyOEg0OUM1MC42NTYyIDI4IDUyIDI5LjM0MzggNTIgMzFWNDNDNTIgNDQuNjU2MiA1MC42NTYyIDQ2IDQ5IDQ2SDI5QzI3LjM0MzggNDYgMjYgNDQuNjU2MiAyNiA0M1YzMVpNMzkgMzcuNDM3NUwyNi43ODEyIDMwLjg0MzhMMzQuNTMxMiAzNi44NzVMMjguMTI1IDQzLjQzNzVMMzUuOTM3NSAzNy44NzVMMzkgMzkuODQzOEw0Mi4wNjI1IDM3Ljg3NUw0OS44NzUgNDMuNDM3NUw0My40Njg4IDM2Ljg3NUw1MS4yMTg4IDMwLjg0MzhMMzkgMzcuNDM3NVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgMailCircle as ReactComponent };